import {HttpErrorResponse,HttpResponse} from '@angular/common/http';
import {Component,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {IMyDateModel,IMyDefaultMonth,IMyDpOptions,IMyOptions} from 'mydatepicker';
import {JhiAlertService} from 'ng-jhipster';
import {BsModalRef,BsModalService} from 'ngx-bootstrap';
// date picker
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {Observable} from 'rxjs';
import {Principal,StateStorageService} from 'src/app/core';
import {ClauseExtensionMySuffixService} from 'src/app/entities/clause-extension-my-suffix';
import {ConfirmationModalComponent} from 'src/app/shared/confirmation-modal/confirmation-modal.component';
import {ConfirmationModelService} from 'src/app/shared/confirmation-modal/confirmation-model.service';
import {MessageConst} from 'src/app/shared/constants/message.constants';
import {IClauseExtensionMySuffix} from 'src/app/shared/model/clause-extension-my-suffix.model';
import {FutureDataType} from 'src/app/shared/model/future_data_type.model';
import {IPolicyMySuffix} from 'src/app/shared/model/policy-my-suffix.model';
import {RuleDeductableRateMySuffix} from 'src/app/shared/model/rule-deductable-rate-my-suffix.model';
import {ScopeClauseSequenceInfo} from 'src/app/shared/model/scope-clause-sequence-info.model';
import {ActiveStatus,IScopeMySuffix,Product,ScopeType} from 'src/app/shared/model/scope-my-suffix.model';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {environment} from 'src/environments/environment';
import {currenyMaskService} from './../../shared/currencyMask.service';
import {PolicyMySuffixService} from './../policy-my-suffix/policy-my-suffix.service';
import {ScopeMySuffixService} from './scope-my-suffix.service';
import { RoleUtil } from 'src/app/shared/util/role-util';
import { TdisConstants } from 'src/app/shared/constants/tdis-constants';


declare let $: any;

@Component({
    selector: 'jhi-scope-my-suffix-update',
    templateUrl: './scope-my-suffix-update.component.html'
})
export class ScopeMySuffixUpdateComponent implements OnInit {

    readonly RoleUtil = RoleUtil;
    readonly TdisConstants = TdisConstants;

    @ViewChild('sequenceModal') sequenceModal: ModalDirective;
    @ViewChild('productModel') productModel: ModalDirective;
    @ViewChild('scopeCertificateViewModal') scopeCertificateViewModal: ModalDirective;
    @ViewChild('deleteExtensionModel') deleteExtensionModel: ModalDirective;

    orderBySequence="sequence"
    extensionFinalArray: any[];
    extensionDeductableFinalList: any[];
    clauseExtensionDeductableList: any[];
    private _scope: IScopeMySuffix;
    isSaving: boolean;
    policyId: number;
    maxChars = 1250;

    keys=Object.keys;
    values=Object.values;
    scopeTypeList;
    scopePreviewString: string='';
    numberPattern='^(?=.*?[1-9])[0-9()-]+$';
    onlyNumberPattern='^[0-9]+$'

    clauseextensions: IClauseExtensionMySuffix[];
    // effectiveDate: string;
    // expiryDate: string;
    policyData: IPolicyMySuffix;

    clauses: IClauseExtensionMySuffix[];
    extensions: IClauseExtensionMySuffix[];
    clausesCopy: IClauseExtensionMySuffix[];
    extensionsCopy: IClauseExtensionMySuffix[];

    printEnableMessage=false;

    dropdownSettings={
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        defaultOpen:false
    };

    // date picker
    dateModel={
        year: new Date().getFullYear(),
        month: new Date().getMonth()+1,
        day: new Date().getDate()
    }
    bsConfig: Partial<BsDatepickerConfig>;
    dob=new Date();
    effectiveDate: any;
    expiryDate: any;
    minExpiryDate=new Date();
    maxExpiryDate=new Date();
    isOpenID=false;
    isOpenED=false;

    inceptionMinDate: Date;
    inceptionMaxDate: Date;
    expiryMinDate: Date;
    expiryMaxDate: Date;
 
    resetDateModel={
        year: 0,
        month: 0,
        day: 0
    }
    inceptionPickerOptions: IMyDpOptions={
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.resetDateModel,
        disableSince: this.resetDateModel,

    };

    expiryDatePickerOptions: IMyDpOptions={
        dateFormat: 'dd/mm/yyyy'
    };



    amountOptions: any;
    rateOptions: any;
    strikeRatePrecisionOptions: any;
    productCopy: any;
    isInsurersCollapsed=true;
    routeId: any;

    // effective date
    date: Date=new Date();
    pastDateModel={year: this.date.getFullYear(),month: this.date.getMonth()+1,day: (this.date.getDate()-1)}
    effectivepDatePickerOptions: IMyOptions={
        dateFormat: 'dd/mm/yyyy',
        disableUntil: this.pastDateModel
    };
    fromEffeciveDate: any;
    dateModelEff={
        year: new Date().getFullYear(),
        month: new Date().getMonth()+1,
        day: new Date().getDate()
    }
    inceptionDateFormate: {year: number; month: number; day: number;};
    expiryDateFormate: {year: number; month: number; day: number;};
    storagePolicyDateOption: {dateFormat: string; disableUntil: any; disableSince: any;};
    public defaultMonth: IMyDefaultMonth={
        defMonth: new Date().getMonth()+1+'/'+new Date().getFullYear()
    };
    isPolicyExpired: boolean=false;
    isScopeExpired: boolean=false;
    isNewScope: boolean=false;
    sType: string=null;
    changeTandCId: number=null;
    isOneTimeScope: boolean=false;
    isOneTimeScopeCreation: boolean=false;
    clauseExtensionClausesList: any[];
    certificateRequestId: any;
    href : any;
    extenstionNamesBefore=new Map();
    isShowWarningForExt=false;
    selectedExtension;
    rules=[];

    maxCharsForDedctDesc = 500;
    maxNameCharForDedctName = 255;
    summaryDetailsUrl: string = '';
    isOts: boolean = false;
    otsKeyword: string = '';
    scopeID: string  = ''; // used to redirect to the scope detial OTS page


    selectedClient=environment.login;
    randomOtsId=null;

    constructor(
        private jhiAlertService: JhiAlertService,
        private scopeService: ScopeMySuffixService,
        private clauseExtensionService: ClauseExtensionMySuffixService,
        private activatedRoute: ActivatedRoute,
        private policyMySuffixService: PolicyMySuffixService,
        private router: Router,
        private principal: Principal,
        private currenyMask: currenyMaskService,
        private modalService: BsModalService,
        private confirmationModelService: ConfirmationModelService,
        private languageChangeService: LanguageChangeService,
        private stateStorageService: StateStorageService
    ) {
                this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
                window.history.back()
            }
    });
    }

    ngOnInit() {
        const CURRENT_URL: string = this.router.url;
        this.isOts=CURRENT_URL.includes('ots');
        
        const isSummaryDetailsUrl: string = localStorage.getItem(MessageConst.CURRENT_URL_SUMMARY_PAGE);
        if(this.isOts && isSummaryDetailsUrl) {
            this.summaryDetailsUrl = JSON.parse(isSummaryDetailsUrl);
            this.otsKeyword = 'ots';
        }

        this.randomOtsId = this.activatedRoute.snapshot.queryParams[ "ranOtsId" ];

        if(this.randomOtsId!=null && this.stateStorageService.contains(this.randomOtsId)) {
            this.summaryDetailsUrl=this.stateStorageService.getCurrentSummaryPageUrl(this.randomOtsId);
            this.isOts=true;
            this.otsKeyword = 'ots';
        }


        window.scrollTo({ top: 0 });
        this.scopeTypeList=ScopeType;
        this.effectivepDatePickerOptions.disableUntil=this.principal.dateFormateServerToClientMin(this.date);
        this.fromEffeciveDate={date: this.dateModelEff};
        this.isInsurersCollapsed=true;
        this.isSaving=false;
        // getting Policy Id from route for add scope
        this.policyId=this.activatedRoute.snapshot.params['policyId'];
        this.sType=this.activatedRoute.snapshot.params['sType'];
        this.scopeID = this.activatedRoute.snapshot.params["id"];

        this.changeTandCId=this.activatedRoute.snapshot.params['changeTandCId'];

        // check activated route Id
        this.routeId=this.activatedRoute.snapshot.params['id'];
        this.rateOptions=this.currenyMask.ratePrecisionOptions;
        this.amountOptions=this.currenyMask.amountPrecisionOptions;
        this.strikeRatePrecisionOptions=this.currenyMask.strikeRatePrecisionOptions;

        this.bsConfig=Object.assign(
            {},
            {
                containerClass: 'custom-datepicker-theme',
                showWeekNumbers: false,
                dateInputFormat: 'DD/MM/YYYY'
            }
        );
        this.activatedRoute.data.subscribe(({scope}) => {
            this.scope=scope;
            if(scope.id) {
                this.policyData=this.scope.policyScope;
                this.getClausesAndExt();

                this.scope.extensionDeductables.forEach(ext => {
                    ext.clauseExtensionList.forEach(item => {
                        this.extenstionNamesBefore.set(item.name,item);
                    })
                })

                console.log("ext:::::"+this.extenstionNamesBefore.keys);
                

            }
        });

        if(this.sType&&this.sType==='One-time') {
            this.scope.scopeType="ONE_TIME" as ScopeType;
            this._scope.scopeType="ONE_TIME" as ScopeType;
            this.isOneTimeScopeCreation=true;
            this.updateScopeType();
        }
 
        this.clauseDeductableList=this.scope.clauseDeductables;
        this.extensionDeductableList=this.scope.extensionDeductables;

        this.certificateRequestId = this.activatedRoute.snapshot.params['crId'];
        console.log(this.certificateRequestId)
        
        if (this.policyId) {
            let forScope;
            if(this.certificateRequestId) {
                forScope =this.policyMySuffixService.findForOneTimeScopeEdit(this.policyId,this.certificateRequestId);
            } else {
                forScope=this.policyMySuffixService.findForScopeEdit(this.policyId);
            }
            
            forScope.subscribe(data => {
                // console.warn(data.body);
                this.policyData = data.body;
                if(this.policyData && this.policyData.scopeDTO && this.policyData.scopeDTO.certificateCommonNumber) {
                    this.scope.certificateCommonNumber = this.policyData.scopeDTO.certificateCommonNumber;
                }
                
                // if (this.scope.id == null) {
                if (CommonUtils.isNil(this.scope.id)) {
                    const inception = this.principal.dateFormateServerToClient(this.policyData.strinceptionDate);
                    const expiry = this.principal.dateFormateServerToClient(this.policyData.strexpiryDate);
                    this.effectiveDate = { date: inception }
                    this.expiryDate = { date: expiry }
                    var defMonth = this.policyData.strinceptionDate.split("-");
                    this.defaultMonth = { defMonth: defMonth[1] + '/' + defMonth[0] };
                    this.isNewScope = true;
                        // var now = new Date();
                        // now.setHours(0,0,0,0);
                        // if (this.policyData.expiryDate < now) {
                        //     this.isPolicyExpired = true;
                        // } else {
                        //     this.isPolicyExpired = false;
                        // }
    
                    this.expiryDatePickerOptions = {
                        dateFormat: 'dd/mm/yyyy',
                        disableUntil: this.principal.dateFormateServerToClientMin(this.policyData.strinceptionDate),
                        disableSince: this.principal.dateFormateServerToClientMax(this.policyData.strexpiryDate)
                    }
                }
    
                this.getClausesAndExt();
    
                this.inceptionPickerOptions = {
                    dateFormat: 'dd/mm/yyyy',
                    disableUntil: this.principal.dateFormateServerToClientMin(this.policyData.strinceptionDate),
                    disableSince: this.principal.dateFormateServerToClientMax(this.policyData.strexpiryDate),
                }

                if(this.policyData.scopeDTO) {
                    this.scope.product=this.policyData.scopeDTO.product;
                    // this.clauseDeductableList=this.policyData.scopeDTO.clauseDeductables;
                    // this.extensionDeductableList=this.policyData.scopeDTO.extensionDeductables;
                    this.scope.isLOIRequired=this.policyData.scopeDTO.isLOIRequired;
                }

            }); 

        }

        if (this.policyData) {
            this.inceptionPickerOptions = {
                dateFormat: 'dd/mm/yyyy',
                disableUntil: this.principal.dateFormateServerToClientMin(this.policyData.strinceptionDate),
                disableSince: this.principal.dateFormateServerToClientMax(this.policyData.strexpiryDate),
            }
            this.expiryDatePickerOptions={
                dateFormat: 'dd/mm/yyyy',
                disableUntil: this.principal.dateFormateServerToClientMin(this.policyData.strinceptionDate),
                disableSince: this.principal.dateFormateServerToClientMax(this.policyData.strexpiryDate)
            }
        }
       
        if(!this.routeId) {
            // by default add one Clause , at least user need add one clause
            // add only for new one , not for update
            this.addClauseDeductable()
        }
    }

    getClausesAndExt() {
        let url='api/clause-extensions/all/mapping';
        let assignToRole="";
        // if(this.policyData.assignToDTO!=null) {
        if(!CommonUtils.isNil(this.policyData.assignToDTO)) {
            assignToRole=this.policyData.assignToDTO[ 'userRole' ];
        // }else if(this.policyData.assignToBrokerDto!=null) {
        }else if(!CommonUtils.isNil(this.policyData.assignToBrokerDto)) {
            assignToRole=this.policyData.assignToBrokerDto[ 'userRole' ];
        // }else if(this.policyData.assignToUnderwriterUserDto!=null) {
        }else if(!CommonUtils.isNil(this.policyData.assignToUnderwriterUserDto)) {
            assignToRole=this.policyData.assignToUnderwriterUserDto[ 'userRole' ];
        }
        if(this.policyData&&this.principal.isAssignedToUnderlyingBrokerOrUnderwriter(this.policyData.createdByUserRole,assignToRole)) {
            url='api/clause-extensions/assigned-policy/'+this.policyData.id;
        }
        this.clauseExtensionService.get(url).subscribe(
            (res: HttpResponse<IClauseExtensionMySuffix[]>) => {
                this.clauseextensions=res.body;
                this.clauses=this.clauseextensions.filter(
                    clause => clause.clauseExtensionType==='CLAUSE'||clause.clauseExtensionType==='BOTH'
                );


                this.clausesCopy=JSON.parse(JSON.stringify(this.clauses));
                this.extensionDeductableList.forEach(item => {
                    item.clauseExtensionList.forEach(list => {
                        this.clauses=this.clauses.filter(ele => ele.id!==list.id)
                    });
                })
                this.extensions=this.clauseextensions.filter(
                    clause => clause.clauseExtensionType==='EXTENSION'||clause.clauseExtensionType==='BOTH'
                );

                this.extensionsCopy=JSON.parse(JSON.stringify(this.extensions));
                this.clauseDeductableList.forEach(item => {
                    item.clauseExtensionList.forEach(list => {
                        this.extensions=this.extensions.filter(ele => ele.id!==list.id)
                    });
                })

            },
            (res: HttpErrorResponse) => this.onError(res.message)
        );
    }


    previousState() {
        // if(this.isOts && this.summaryDetailsUrl) {
            
        // } else {
        //     window.history.back();
        // }
        this.principal.showAlertOnCancel.next(true);
        window.history.back();
    }

    saveScope() {
        if (this.scope.description.length > 1250) {
            this.jhiAlertService.error('Scope description must be less than 1250');
            return;
        }
        if(this.scope.id) {
            this.checkExtensions();
        } else {
            this.showSequenceModal();
        }
        // if(this.scope.deductibleType!=DeductibleType.NO_DEDUCTIBLE) {
        // } else {
        //     this.save();
        // }
    }

    scopeId:any;
    private subscribeToSaveResponse(result: Observable<HttpResponse<IScopeMySuffix>>) {
        result.subscribe((res: HttpResponse<IScopeMySuffix>) => this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError(res));
    }

    private onSaveSuccess(res) {
        console.log(res.body.id)        
        if (this.sType && this.sType === 'One-time') {
            this.isSaving = false;
            this.deleteExistedFutureRecordDetails();
            if(this.certificateRequestId) {
                this.router.navigate(['/rule-my-suffix/new/'+res.body.id+'/ots/'+this.certificateRequestId],{queryParams:{ranOtsId:this.randomOtsId}});
            } else {
                this.router.navigateByUrl('/rule-my-suffix/new/'+res.body.id);
            }
        } else if(this.scopeID && this.isOts && this.summaryDetailsUrl) {
            this.router.navigate(['scope-my-suffix/'+this.scopeID+'/ots/view'],{queryParams:{ranOtsId:this.randomOtsId}});
        } else{
            this.isSaving = false;
            this.deleteExistedFutureRecordDetails();
            // this.previousState();
            let policyId = this.policyId ? this.policyId : this.policyData.id;
            this.router.navigateByUrl('/policy/' + policyId + '/view');
        }
   
    }

    private onSaveError(res) {
        this.isSaving=false;
        this.jhiAlertService.error(res.error.message)
    }

    private onError(errorMessage: string) {
        this.jhiAlertService.error(errorMessage,null,null);
    }

    trackClauseExtensionById(index: number,item: IClauseExtensionMySuffix) {
        return item.id;
    }

    getSelected(selectedVals: Array<any>,option: any) {
        if(selectedVals) {
            for(let i=0;i<selectedVals.length;i++) {
                if(option.id===selectedVals[i].id) {
                    return selectedVals[i];
                }
            }
        }
        return option;
    }
    get scope() {
        return this._scope;
    }

    set scope(scope: IScopeMySuffix) {
        this._scope=scope;
        let inception=this.principal.dateFormateServerToClient(scope.streffectiveDate);
        let expiry=this.principal.dateFormateServerToClient(scope.strexpiryDate);
        this.effectiveDate={date: inception};
        this.expiryDate={date: expiry};


        if(scope.id) {
            this.productCopy=scope.product;
        }
        if(scope.id) {
            var defMonth=scope.streffectiveDate.split("-");
            this.defaultMonth={defMonth: defMonth[1]+'/'+defMonth[0]};
            this.inceptionDateFormate=this.principal.dateFormateServerToClientMin(scope.effectiveDate);
            this.expiryDateFormate=this.principal.dateFormateServerToClientMax(scope.expiryDate);

            this.expiryDatePickerOptions={
                dateFormat: 'dd/mm/yyyy',
                disableUntil: this.principal.dateFormateServerToClientMin(scope.streffectiveDate)
            }

            this.effectivepDatePickerOptions={
                dateFormat: 'dd/mm/yyyy',
                disableUntil: this.pastDateModel,
                disableSince: this.expiryDateFormate,
            };

            if(scope.activeStatus===ActiveStatus.IN_ACTIVE) {
                this.isNewScope=true;
            }

            // this.isScopeExpired = this.isPolicyExpired;
            // if(!this.isScopeExpired){
            //     var now = new Date();
            //     now.setHours(0,0,0,0);
            //     if (scope.expiryDate < now) {
            //         this.isScopeExpired = true;
            //     } else {
            //         this.isScopeExpired = false;
            //     }
            // }
            this.updateScopeType();
        }


    }

    updateScopeType() {
        if(this.scope.scopeType==='GENERIC') {
            this.scope.maximumUseLimit=null;
            this.isOneTimeScope=false;
        } else {
            this.isOneTimeScope=true;
            if(this.scope.product&&this.scope.product==='STORAGE') {
                this.scope.product=null;
            }
        }
    }

    setDateFormat(inception,expiry) {
        //this.effectiveDate = new Date(inception);
        //this.expiryDate = new Date(expiry);
    }

    showSequenceModal(): void {
        this.scope.clauseDeductables=this.clauseDeductableList;
        this.scope.extensionDeductables=this.extensionDeductableList;
        this.scope.scopeClauseSequenceInfoDTOs=[];
        let clauseList=[];

        this.scope.clauseDeductables.forEach(element => {

            element.clauseExtensionList.forEach(element => {
                clauseList.push(element);
            });

        });
        this.checkPrintStatusClause();
        if(clauseList&&clauseList.length>0) {
            for(let i=0;i<clauseList.length;i++) {
                let sequence=new ScopeClauseSequenceInfo();
                sequence['policyId']=this.policyId;
                sequence['clauseExtensionId']=clauseList[i].id;
                sequence['clauseExtensionName']=clauseList[i].name;
                sequence['sequence']=(i+1);
                this.scope.scopeClauseSequenceInfoDTOs.push(sequence);
            }
            this.sequenceModal.show();
        } else {
            // this.save();
            this.scopeCertificateModalshow();
        }
    }
    scopeCertificateModalshow() {
        this.sequenceModal.hide();
        this.extensionDeductableList.map(ele => {
            ele.clauseExtensionList.map(clause => {
                clause.checked=true;
            })
        })
        this.getClauseExtensionDescription();
        this.scopeCertificateViewModal.show();
    }
    hideScopeCertificateModal() {
        this.scopeCertificateViewModal.hide();
    }
    checkPrintStatusClause(): void {
        this.printEnableMessage=false;
        this.scope.clauseDeductables.forEach((list) => {
            let listElement: any=list;

            listElement.clauseDeductables.forEach(innerElement => {
                let object: any=innerElement

                if(object&&object.printEnable) {
                    this.printEnableMessage=true;
                    console.log(' IFFFFF ');
                    return;
                }

            });

        });

        if(!this.printEnableMessage) {
            this.checkPrintStatusExtesnion();
        }
    }

    checkPrintStatusExtesnion(): void {
        console.log('   extensionDeductables');
        this.printEnableMessage=false;
        this.scope.extensionDeductables.forEach((list) => {
            let listElement: any=list;
            console.log('   extensionDeductables Loop1');
            listElement.extensionDeductables.forEach(innerElement => {
                let object: any=innerElement
                console.log('   extensionDeductables Loop2');

                if(object&&object.printEnable) {
                    this.printEnableMessage=true;
                    console.log(' IFFFFF  extensionDeductables');
                    return;
                }

            });

        });
    }
    onSelectAllClauseAndExtension(type,event) {
        if(type==='extension') {
            for(let j=0;j<event.length;j++) {
                this.clauses=this.clauses.filter(item => item.id!==event[j].id);
            }
        } else {
            for(let j=0;j<event.length;j++) {
                this.extensions=this.extensions.filter(item => item.id!==event[j].id);
            }
        }
    }
    onDeSelectAllClauseAndExtension(type,event) {
        if(type==='extensions') {
            $(document).find('.clauseExtension2 .dropdown-list').addClass('showDropdown');
            for(let i=0;i<this.extensions.length;i++) {
                if(this.extensions[i].clauseExtensionType=='BOTH') {
                    this.clauses.push(this.extensions[i]);
                    this.clauses=this.clauses.filter(item => true);
                }
            }
        } else {
            $(document).find('.clauseExtension1 .dropdown-list').addClass('showDropdown');
            for(let i=0;i<this.clauses.length;i++) {
                if(this.clauses[i].clauseExtensionType=='BOTH') {
                    this.extensions.push(this.clauses[i]);
                    this.extensions=this.extensions.filter(item => true);
                }
            }
        }
    }

    onPasteNoOfTimes(event) {
        let clipboardData=event.clipboardData;
        let pastedText=clipboardData.getData('text');
        let regexp=new RegExp(/^[0-9]+$/);
        console.log(regexp.test(pastedText));
        if(regexp.test(pastedText)) {
            if(pastedText.length>4) {
                //this.maxLength = 7;
                return false;
            }
            //  this.shippingDetail.meansOfConveyanceNumber = pastedText.trim();
            return true;
        } else {
            return false;
        }
    }

    filterClauseAndExtenstionsData(type,event) {
        // if the type is extension and event.type == 'BOTH' then remove that item from clauses 
        if(type==='extension') {
            this.clauses=this.clauses.filter(item => item.id!==event.id);
            console.log(this.clauses);
            // else remove from extension
        } else {
            $(document).find('.clauseExtension1 .dropdown-list').addClass('showDropdown');
            this.extensions=this.extensions.filter(item => item.id!==event.id);
            console.log(this.extensions);
        }
    }


    deSelectClauseAndExtenstionsData(type,event) {
        if(type==='extension') {
            // On deselect the item check whether item exit or not , if not exit add that item to extension list
            if(this.extensions.length==0) {
                // this the showing the selected list with checkboxes in deselect one item from all selected list
                this.extensions=[...this.extensionsCopy];
                // below code for remove both item if selected in clauses
                for(let i=0;i<this.clauseDeductableList.length;i++) {
                    this.clauseDeductableList[i].clauseExtensionList.map(ele => {
                        this.extensions=this.extensions.filter(item => item.id!==ele.id)
                    })
                }
            }
            let findItemExit=this.extensions.findIndex(element => element.id==event.id);
            let localExtension: any=this.extensionsCopy.find(element => element.id==event.id);
            if(findItemExit==-1) {
                this.extensions=[...this.extensions,...localExtension]
                this.extensions=this.extensions.map(item => item);
                this.extensions.sort((n1,n2) => {
                    if(n1.name>n2.name) {
                        return 1;
                    }
                    if(n1.name<n2.name) {
                        return -1;
                    }

                    return 0;
                });
            }

            console.log("from extension list",this.extensions);

            // data clausextension type is both then add in clauses list data item.
            // if (event.clauseExtensionType == "BOTH") {
            let clause;
            clause=this.clausesCopy.filter(k => k.id===event.id);
            if(clause.length>0) {
                // this.clauses.push(clause[0]);
                this.clauses=[...this.clauses,...clause]
                this.clauses=this.clauses.map(item => item);
                this.clauses.sort((n1,n2) => {
                    if(n1.name>n2.name) {
                        return 1;
                    }

                    if(n1.name<n2.name) {
                        return -1;
                    }

                    return 0;
                });
            }
            // }
           
        } else {
            // On deselect the item check whether item exit or not , if not exit add that item to clauses list
            let localClause=this.clausesCopy.filter(element => element.id==event.id);
            if(this.clauses.length==0) {
                this.clauses=[...this.clausesCopy];
                // below code for remove both item if selected in extensions
                for(let i=0;i<this.extensionDeductableList.length;i++) {
                    this.extensionDeductableList[i].clauseExtensionList.map(ele => {
                        this.clauses=this.clauses.filter(item => item.id!==ele.id)
                    })
                }

            }
            if(localClause.length>0) {
                let findItemExitinClauses=this.clauses.findIndex(element => element.id==event.id);
                if(findItemExitinClauses==-1) {
                    this.clauses=[...this.clauses,...localClause];
                    // this.clauses.push(localClause[0]);
                    this.clauses=this.clauses.map(item => item);
                    this.clauses.sort((n1,n2) => {
                        if(n1.name>n2.name) {
                            return 1;
                        }
                        if(n1.name<n2.name) {
                            return -1;
                        }

                        return 0;
                    });
                }
            }

            // data clausextension type is both then add in clauses list data item.
            // if (event.clauseExtensionType == "BOTH") {
            let extension;
            extension=this.extensionsCopy.filter(k => k.id===event.id);
            if(extension.length>0) {
                this.extensions.push(extension[0]);
                this.extensions=this.extensions.map(item => item);
                this.extensions.sort((n1,n2) => {
                    if(n1.name>n2.name) {
                        return 1;
                    }
                    if(n1.name<n2.name) {
                        return -1;
                    }
                    return 0;
                });
            }
        }
    }

    extensionClickEvent(data) {
        console.log(" extenion click evnet");
        // New Logic for filter data on add new item for clauses
        let copyExtension=[...this.extensions]
        for(let i=0;i<this.extensionDeductableList.length;i++) {
            this.extensionDeductableList[i].clauseExtensionList.map(ele => {
                copyExtension=copyExtension.filter(element => element.id!==ele.id);
            })
        }
        copyExtension=[...copyExtension,...data];
        // remove duplicates
        // Array to keep track of duplicates
        let dups=[];
        let arr=copyExtension.filter(function(el) {
            // If it is not a duplicate, return true
            if(dups.indexOf(el.id)==-1) {
                dups.push(el.id);
                return true;
            }
            return false;
        });
        copyExtension=arr;
        copyExtension.sort((n1,n2) => {
            if(n1.name>n2.name) {
                return 1;
            }
            if(n1.name<n2.name) {
                return -1;
            }

            return 0;
        });
        setTimeout(() => {
            this.extensions=copyExtension;
            console.log("from click list",this.extensions);
        },0);
    }

    clausesClickEvent(data) {
        console.log("clauses click evnet");
        // New Logic for filter data on add new item for clauses
        let copyClaues: any=[...this.clauses]
        for(let i=0;i<this.clauseDeductableList.length;i++) {
            this.clauseDeductableList[i].clauseExtensionList.map(ele => {
                copyClaues=copyClaues.filter(element => element.id!==ele.id);
            })
        }
        copyClaues=[...copyClaues,...data];
        // remove duplicates
        // Array to keep track of duplicates
        let dups=[];
        let arr=copyClaues.filter(function(el) {
            // If it is not a duplicate, return true
            if(dups.indexOf(el.id)==-1) {
                dups.push(el.id);
                return true;
            }
            return false;
        });
        copyClaues=arr;
        copyClaues.sort((n1,n2) => {
            if(n1.name>n2.name) {
                return 1;
            }
            if(n1.name<n2.name) {
                return -1;
            }

            return 0;
        });
        setTimeout(() => {
            this.clauses=copyClaues;
            this.clauses=this.clauses.map(item => item);
        },0);

    }


    onSelectAll(type,event) {
        if(type==='extensions') {
            $(document).find('.clauseExtension2 .dropdown-list').addClass('showDropdown');

            for(let i=0;i<event.length;i++) {
                let data=this.clausesCopy.filter(item => item.id!==event[i].id);
                this.clauses=data;
            }
            this.clauses=this.clauses.map(item => item);
        } else {
            $(document).find('.clauseExtension1 .dropdown-list').addClass('showDropdown');

            for(let i=0;i<event.length;i++) {
                let data=this.extensionsCopy.filter(item => item.id!==event[i].id);
                this.extensions=data;
            }

            this.extensions=this.extensions.map(item => item);
        }
    }

    dateFormateChange(date) {
        let initDate=new Date(date);
        let day=('0'+initDate.getDate()).slice(-2);

        let month=('0'+(initDate.getMonth()+1)).slice(-2);

        let year=initDate.getFullYear();

        return year+'-'+month+'-'+day;
    }

    save() {
        let fromEffectiveDate=this.principal.dateFormateClientToServer(this.fromEffeciveDate.date);
        this.scope.fromEffectiveDate=fromEffectiveDate;
        this.openConfirmationModalForFutureRecordDeletion();
    }

    saveOrUpdate() {
        this.isSaving=true;
        this.hideSequenceModal();

        let incDate=this.principal.dateFormateClientToServer(this.effectiveDate.date);
        let expDate=this.principal.dateFormateClientToServer(this.expiryDate.date);
        // final update
        this.scope.streffectiveDate=incDate;
        this.scope.strexpiryDate=expDate;


        if(this.changeTandCId) {
            this.scope.changeTandCId=this.changeTandCId;
        }
        

        if(this.scope.deductibleType==="NO_DEDUCTIBLE") {
            this.clauseDeductableList.forEach(clause => {
                clause.clauseDeductables=[];
            });
            this.extensionDeductableList.forEach(ext => {
                ext.extensionDeductables=[];
            });
        }

        // this.scope.effectiveDate = moment(this.effectiveDate, DATE_TIME_FORMAT)
        //     .utcOffset(0)
        //     .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        // this.scope.expiryDate = moment(this.expiryDate, DATE_TIME_FORMAT)
        //     .utcOffset(0)
        //     .set({ hour: 0, minute: 0, second: 0, millisecond: 0 });


        // if(this.scope.deductibleType==DeductibleType.NO_DEDUCTIBLE) {
        //     this.scope.clauseDeductables=[];
        //     this.scope.extensionDeductables=[];
        // } else {
        // }
        //clause mandatory validation
        if(this.scope.clauseDeductables.length==0) {
            this.onError('Clause Deductible is required');
            return;
        }


        if(this.scope.id) {
            if(this.productCopy=='STORAGE'&&this.scope.product!=this.productCopy) {
                this.hideScopeCertificateModal();
                this.productModel.show();
                return;
            } else if(this.scope.product=='STORAGE'&&this.scope.product!=this.productCopy) {
                this.hideScopeCertificateModal();
                this.productModel.show();
                return;
            }
        }
        // if(this.scope.id==undefined&&this.scope.scopeType==ScopeType.ONE_TIME&&(this.scope.maximumUseLimit==0||this.scope.maximumUseLimit==undefined)) {
        if(CommonUtils.isNil(this.scope.id)&&this.scope.scopeType==ScopeType.ONE_TIME&&(this.scope.maximumUseLimit==0||CommonUtils.isNil(this.scope.maximumUseLimit))) {
            this.scope.maximumUseLimit=1;
        }
        if(incDate<=expDate) {
            this.scope.effectiveDate=null //this.scope.effectiveDate != null ? new Date(this.scope.effectiveDate) : null;
            this.scope.expiryDate=null//this.scope.expiryDate != null ? new Date(this.scope.expiryDate) : null;

            this.scope.policyScope=this.policyData;
            if(this.policyData.lineOfBusiness === TdisConstants.LineOfBusiness.MOVERS) {
                this.scope.product = Product.MARINE_CARGO_INSURANCE;
            }
            // if(this.scope.id!==undefined) {
            if(CommonUtils.isNotNil(this.scope.id)) {
                this.subscribeToSaveResponse(this.scopeService.update(this.scope));
                // console.warn(this.scope);
            } else {
                this.subscribeToSaveResponse(this.scopeService.create(this.scope));
            }
        } else {
            this.onError('Expiry Date is Less Than Inception Date');
        }


        this.scope.clauseDeductables = this.clauseDeductableList;
        this.scope.extensionDeductables = this.extensionDeductableList;
        
    }

    hideSequenceModal(): void {
        this.sequenceModal.hide();
    }

    allowNumbers(event) {
        // const key = window.event ? event.keyCode : event.which;
        // if (key > 31 && (key < 48 || key > 57)) {
        //     return false;
        // } else {
        //     return true;
        // }
        const charCode=event.which? event.which:event.keyCode;
        if(charCode===46) {
            return true;
        } else if(charCode>31&&(charCode<48||charCode>57)) {
            return false;
        } else {
            return true;
        }
    }





    isclauseDeductableCollapsed=true;
    isExtensionDeductableCollapsed=true;
    // isMarine = true;
    // isMarine = true;





    // For Clauses

    clauseDeductableList: any[]=[
        {
            clauseExtensionList: [],
            clauseDeductables: [{decuctableName: null,percentage: null,decuctableDescription: null}]
        }
    ];

    addClauseDeductable() {
        console.log("this.clauses before",this.clauses);
        let obj={
            clauseExtensionList: [],
            clauseDeductables: [{decuctableName: null,percentage: null,decuctableDescription: null,printEnable: true}]
        };
        this.clauseDeductableList.push(obj);
        // New Logic for filter data on add new item for clauses
        for(let i=0;i<this.clauseDeductableList.length-1;i++) {
            this.clauseDeductableList[i].clauseExtensionList.map(ele => {
                this.clauses=this.clauses.filter(element => element.id!==ele.id);
            })
        }
        console.log("this.clauses after",this.clauses);

    }

    removeClauseDeductable(index: number,data) {
        this.clauseDeductableList.splice(index,1);
        // New logic for adding clauses to clauses after deletion of row 
        console.log(data);
        let newdata=[...data]
        if(newdata) {
            // adding the data
            let bothDataType=[];
            newdata.map(item => {
                // check the whether the item exit or not
                let checkItemExit=this.clauses.findIndex(element => element.id==item.id);
                if(checkItemExit==-1) {
                    this.clauses.push(item);
                }
                // check BOTH type exit in extension copy array 
                bothDataType=[...bothDataType,...this.extensionsCopy.filter(filterItem => filterItem.id==item.id)]
            })
            // push  that both data into extension array if remove from clauses 
            this.extensions=[...this.extensions,...bothDataType];
            // sorting the data  for clauses 
            this.clauses=this.clauses.map(item => item);
            this.clauses.sort((n1,n2) => {
                if(n1.name>n2.name) {
                    return 1;
                }
                if(n1.name<n2.name) {
                    return -1;
                }

                return 0;
            });
            // sort extension array
            this.extensions=this.extensions.map(item => item);
            this.extensions.sort((n1,n2) => {
                if(n1.name>n2.name) {
                    return 1;
                }
                if(n1.name<n2.name) {
                    return -1;
                }

                return 0;
            });
        }
    }

    addClauseDeductableRates(index) {
        const deductable=new RuleDeductableRateMySuffix();
        this.clauseDeductableList[index].clauseDeductables.push(deductable);
    }


    // For Extensions
    extensionDeductableList: any[]=[
        {
            clauseExtensionList: [],
            extensionDeductables: [{decuctableName: null,percentage: null,decuctableDescription: null}]
        }
    ];

    addExtensionDeductable() {
        console.log("this.extension before",this.extensions);
        let obj={
            clauseExtensionList: [],
            extensionDeductables: [{decuctableName: null,percentage: null,decuctableDescription: null}]
        };
        this.extensionDeductableList.push(obj);
        for(let i=0;i<this.extensionDeductableList.length;i++) {
            this.extensionDeductableList[i].clauseExtensionList.map((ele,indexNumber) => {
                this.extensions=this.extensions.filter(element => element.id!==ele.id)
            })
        }
        console.log("this.extension after",this.extensions);
    }

    removeExtensionDeductable(index: number,data) {
        this.extensionDeductableList.splice(index,1);

        // New logic for adding exntensions to extensions after deletion of row 
        console.log(data);
        let newdata=[...data]
        if(newdata) {
            let bothDataType=[];
            // adding the data
            newdata.map(item => {
                // check the whether the item exit or not
                let checkItemExit=this.extensions.findIndex(element => element.id==item.id);
                if(checkItemExit==-1) {
                    this.extensions.push(item);
                }
                // check BOTH type exit in extension copy array 
                bothDataType=[...bothDataType,...this.clausesCopy.filter(filterItem => filterItem.id==item.id)]
            })

            // push the BOTH data type in clauses
            this.clauses=[...this.clauses,...bothDataType];

            // sorting the data 
            this.extensions=this.extensions.map(item => item);
            this.extensions.sort((n1,n2) => {
                if(n1.name>n2.name) {
                    return 1;
                }
                if(n1.name<n2.name) {
                    return -1;
                }

                return 0;
            });

            // sort clauses data
            this.clauses=this.clauses.map(item => item);
            this.clauses.sort((n1,n2) => {
                if(n1.name>n2.name) {
                    return 1;
                }
                if(n1.name<n2.name) {
                    return -1;
                }

                return 0;
            });
        }
    }



    addExtensionDeductableRates(index) {
        const deductable=new RuleDeductableRateMySuffix();
        this.extensionDeductableList[index].extensionDeductables.push(deductable);
    }
    removeExtensionDeductableRates(i,j) {
        this.extensionDeductableList[i].extensionDeductables.splice(j,1);
    }

    removeClauseDeductableRates(i,j) {
        this.clauseDeductableList[i].clauseDeductables.splice(j,1);
    }

    deductableChangeInClause(event,i,j,data) {
        console.log(' CLAUSE ::: ****** i - j :: ',i,' # ',j,' #',event.target.value,this.clauseDeductableList);
        // on change of flat value reset whole line level data
        if(this.clauseDeductableList[i].clauseDeductables[j]) {

            this.clauseDeductableList[i].clauseDeductables[j].decuctableName='';
            this.clauseDeductableList[i].clauseDeductables[j].decuctableDescription=''
            this.clauseDeductableList[i].clauseDeductables[j].flatPercentage='';
            this.clauseDeductableList[i].clauseDeductables[j].flatValue='';
            this.clauseDeductableList[i].clauseDeductables[j].maximumValue='';
            this.clauseDeductableList[i].clauseDeductables[j].minimumValue='';
            this.clauseDeductableList[i].clauseDeductables[j].percentage='';
            if(event.target.value==='FLAT_PERCENTAGE') {
                this.clauseDeductableList[i].clauseDeductables[j].flatPercentage=0;
            } else if(event.target.value==='FLAT_VALUE') {
                this.clauseDeductableList[i].clauseDeductables[j].flatValue=0;
                this.clauseDeductableList[i].clauseDeductables[j].applicableOn=null;
            } else if(event.target.value==='MINIMUM_AND_MAXIMUM_VALUE_AND_A_PERCENTAGE') {
                this.clauseDeductableList[i].clauseDeductables[j].maximumValue=0;
                this.clauseDeductableList[i].clauseDeductables[j].minimumValue=0;
                this.clauseDeductableList[i].clauseDeductables[j].percentage=0;
            }
        }
    }

    deductableChangeInExtension(event,i,j) {
        console.log(' EXTENSION ::: ****** i - j :: ',i,' # ',j,' #',event.target.value,this.clauseDeductableList);
        // on change of flat value reset whole line level data
        if(this.extensionDeductableList[i].extensionDeductables[j]) {
            this.extensionDeductableList[i].extensionDeductables[j].decuctableDescription=''
            this.extensionDeductableList[i].extensionDeductables[j].decuctableName='';
            this.extensionDeductableList[i].extensionDeductables[j].flatPercentage='';
            this.extensionDeductableList[i].extensionDeductables[j].flatValue='';
            this.extensionDeductableList[i].extensionDeductables[j].maximumValue='';
            this.extensionDeductableList[i].extensionDeductables[j].minimumValue='';
            this.extensionDeductableList[i].extensionDeductables[j].percentage='';
            if(event.target.value==='FLAT_PERCENTAGE') {
                this.extensionDeductableList[i].extensionDeductables[j].flatPercentage=0;
            } else if(event.target.value==='FLAT_VALUE') {
                this.extensionDeductableList[i].extensionDeductables[j].flatValue=0;
                this.extensionDeductableList[i].extensionDeductables[j].applicableOn=null;
            } else if(event.target.value==='MINIMUM_AND_MAXIMUM_VALUE_AND_A_PERCENTAGE') {
                this.extensionDeductableList[i].extensionDeductables[j].maximumValue=0;
                this.extensionDeductableList[i].extensionDeductables[j].minimumValue=0;
                this.extensionDeductableList[i].extensionDeductables[j].percentage=0;
            }
        }


    }




    trackIdByClauseDeductableList(index,item: any) {
        return index;
    }

    trackIdByClauseDeductables(index,item: any) {
        return index;
    }

    trackIdByExtensionDeductableList(index) {
        return index;
    }

    trackIdByExtensionDeductables(index,item: any) {
        return item.id;
    }

    trimScopeDescription($event) {
        this.scope.description=this.scope.description.trim();
    }
    trimField(event) {
        if(event.target.value) {
            event.target.value=event.target.value.trim()
        }
    }
    onDropdownCargoClose() {
        $(document)
            .find('.clauseExtension1 .dropdown-list')
            .removeClass('showDropdown');
    }

    onDropdownCloseClause1() {
        $(document)
            .find('.clauseExtension1 .dropdown-list')
            .removeClass('showDropdown');
    }

    onDropdownCloseClause2() {
        $(document)
            .find('.clauseExtension2 .dropdown-list')
            .removeClass('showDropdown');
    }

    trimName(event) {
        if(this.scope.name) {
            this.scope.name=this.scope.name.trim();
        }
    }

    blockEnterKey(event) {
        if(event.which=='13') {
            event.preventDefault();
            return false;
        }
        return this.numberOnly(event);
    }

    blockEnterKeyForDropdown(event) {
        if(event.which=='13') {
            event.preventDefault();
            return false;
        }
    }

    numberOnly(event) {
        const charCode=event.which? event.which:event.keyCode;
        if(charCode===44) {
            return true;
        } else if(charCode>31&&(charCode<48||charCode>57)) {
            return false;
        } else {
            return true;
        }
    }

    printEnableSetClauseFlag(parentIndex,childIndex) {
        let clause;
        console.log("value of I And J ",this.clauseDeductableList[parentIndex].clauseDeductables[childIndex]);
        clause=this.clauseDeductableList[parentIndex];

        for(let index=0;index<clause.clauseDeductables.length;index++) {
            if(index===childIndex) {
                clause.clauseDeductables[childIndex].printEnable=true;

                //&&  clause.clauseDeductables[childIndex].printEnable ===true
            } else {
                clause.clauseDeductables[index].printEnable=false;
            }

        }

        console.log(" childIndex",clause.clauseDeductables[childIndex].printEnable);

        console.log("print value in length",clause.clauseDeductables.length);

    }

    printEnableSetExtesnionFlag(parentIndex,childIndex) {
        let extesnion;
        console.log("value of I And J ",this.extensionDeductableList[parentIndex].extensionDeductables[childIndex]);
        extesnion=this.extensionDeductableList[parentIndex];

        for(let index=0;index<extesnion.extensionDeductables.length;index++) {
            if(index===childIndex) {
                extesnion.extensionDeductables[childIndex].printEnable=true;

                //&&  clause.clauseDeductables[childIndex].printEnable ===true
            } else {
                extesnion.extensionDeductables[index].printEnable=false;
            }

        }
    }

    hideProductModel() {
        this.scope.product=this.productCopy;
        this.productModel.hide();
    }
    proceedToSave() {
        this.productCopy=this.scope.product;
        this.save();
    }

    changeStorageDateRange(event,status) {

        if(status=='INCEPTION') {
            this.expiryDate=null;
            // if(event!=null&&event.jsdate!=null) {
            if(!CommonUtils.isNil(event)&&!CommonUtils.isNil(event.jsdate)) {
                this.inceptionDateFormate=this.principal.dateFormateServerToClientMin(event.jsdate);
                this.expiryDatePickerOptions={
                    dateFormat: 'dd/mm/yyyy',
                    disableUntil: this.inceptionDateFormate,
                }

                var defMonth=event.formatted.split("/");
                this.defaultMonth={defMonth: defMonth[1]+'/'+defMonth[2]};
            }

        } else {
            // if(event!=null&&event.jsdate!=null) {
            if(!CommonUtils.isNil(event)&&!CommonUtils.isNil(event.jsdate)) {
                this.expiryDateFormate=this.principal.dateFormateServerToClientMax(event.jsdate);

                this.effectivepDatePickerOptions={
                    dateFormat: 'dd/mm/yyyy',
                    disableUntil: this.pastDateModel,
                    disableSince: this.expiryDateFormate,
                };

                this.fromEffeciveDate={date: this.dateModel};
            }
        }
    }

    onDateChanged(event: IMyDateModel) {
        // if(this.scope.id!==null&&this.scope.id!==undefined) {
        if(!CommonUtils.isNil(this.scope.id)) {
            let selectedFromEffectiveDate=this.principal.dateFormateClientToServer(event.date)
            console.log('onDateChanged(): ',selectedFromEffectiveDate);
            this.scopeService.findByIdAndFromEffectiveDate(this.scope.id,selectedFromEffectiveDate).subscribe(response => {
                console.log(response);
                // if(response.body!=null&&response.body['isSuccess']) {
                if(!CommonUtils.isNil(response.body)&&response.body['isSuccess']) {
                    this.scope=response.body['payLoad'];

                    if(new Date(this.scope.expiryDate).getTime()<new Date(selectedFromEffectiveDate).getTime()) {
                        this.fromEffeciveDate={date: this.dateModel};
                    }

                    this.clauseDeductableList=this.scope.clauseDeductables;
                    this.extensionDeductableList=this.scope.extensionDeductables;
                    // this for updating the data for clauses and extensions
                    this.extensionDeductableList.forEach(item => {
                        item.clauseExtensionList.forEach(list => {
                            this.clauses=this.clausesCopy.filter(ele => ele.id!==list.id)
                        });
                    })
                    this.clauseDeductableList.forEach(item => {
                        item.clauseExtensionList.forEach(list => {
                            this.extensions=this.extensionsCopy.filter(ele => ele.id!==list.id)
                        });
                    })
                }
            });
        }
    }


    // global modal open and close event
    bsModalRef: BsModalRef;

    isConfirmDeletion=false;
    /* this is how we open a Modal Component from another component */
    openConfirmationModalForFutureRecordDeletion() {
        this.isConfirmDeletion=false;
        // if(this.scope.id!==null&&this.scope.id!==undefined) {
        if(CommonUtils.isNotNil(this.scope.id)) {
            let form_data={
                masterId: this.scope.id,
                futureDataType: FutureDataType.SCOPE.valueOf(),
                fromEffectiveDateFormatted: this.scope.fromEffectiveDate
            }
            this.confirmationModelService.findFutureRecordExisted(form_data).subscribe(response => {
                const resBody=response.body;
                if(resBody.isSuccess) {
                    const initialState={
                        title: 'Rule',
                        message: resBody.message,
                    };
                    this.bsModalRef=this.modalService.show(ConfirmationModalComponent,{initialState,class: "modal-lg"});
                    this.bsModalRef.content.onClose.subscribe(result => {
                        if(result) {
                            this.isConfirmDeletion=true;
                            this.saveOrUpdate();
                        }
                    });
                } else {
                    this.saveOrUpdate();
                }
            });

        } else {
            this.saveOrUpdate();
        }
    }


    deleteExistedFutureRecordDetails() {
        if(this.isConfirmDeletion) {
            let form_data={
                masterId: this.scope.id,
                futureDataType: FutureDataType.SCOPE.valueOf(),
                fromEffectiveDateFormatted: this.scope.fromEffectiveDate
            }
            this.confirmationModelService.deleteExistedFutureRecord(form_data).subscribe(response => {
                console.log(response);
                this.isConfirmDeletion=false;
            });
        }
    }
    handleEnterKeyPress(event) {
        const tagName=event.target.tagName.toLowerCase();
        if(tagName!=='textarea') {
            return false;
        }
    }

    // form save event , check whether form valid or not 
    // if user enter top grid section and  forgot to add clauses data,  then we need open clauses panel
    // At least one clauses data should be entered
    formSave(valid) {
        if(valid) {
            // noting to do

        } else {
            this.isclauseDeductableCollapsed=false;
        }
    }
    public removeItem(item: any,list: any[]): void {
        list.splice(list.indexOf(item),1);
    }

    public onDropEvent(item: any,list: any[]): void {
        for(var i=0;i<this.scope.scopeClauseSequenceInfoDTOs.length;i++) {
            this.scope.scopeClauseSequenceInfoDTOs[i].sequence=(i+1);
        }
        console.log(list);
    }
    getClauseExtensionDescription() {
        this.scope.scopeClauseSequenceInfoDTOs;
        

        this.extensionFinalArray=[];
        this.extensionDeductableFinalList=[];
        this.clauseExtensionDeductableList=[];
        this.clauseExtensionClausesList=[];
        this.clauseDeductableList.map(clause => {
            clause.clauseDeductables.map(clauseDesc => {
                if(clauseDesc.printEnable&&clauseDesc.decuctableDescription) {
                    this.clauseExtensionDeductableList.push(clauseDesc)
                }
            })
            clause.clauseExtensionList.map(extesnion => {
                let selectedExtension=this.clausesCopy.filter(item => item&&item.id&&item.id==extesnion.id)
                if(selectedExtension&&selectedExtension.length>0) {
                    this.clauseExtensionClausesList.push(selectedExtension[0]);
                }
               
            })
        })
        this.extensionDeductableList.map(extension => {
            let selectedExtensionDeductableExtension=0;
            // if the extension with deductable , extensions with at least one is selected we need show the extension deductable
            if(extension.clauseExtensionList.length>0) {
                extension.clauseExtensionList.map(extDesc => {
                    if(extDesc['checked']) {
                        let selectedExtension=this.extensionsCopy.filter(item => item.id==extDesc.id)
                        this.extensionFinalArray.push(selectedExtension[0]);
                        selectedExtensionDeductableExtension=selectedExtensionDeductableExtension+1
                    }
                })
                if(selectedExtensionDeductableExtension>0) {
                    extension.extensionDeductables.map(desc => {
                        if(desc.printEnable&&desc.decuctableDescription) {
                            this.extensionDeductableFinalList.push(desc)
                        }
                    })
                }

            }
        })
        let clauseDiscriptionInSequence=[];
        this.scope.scopeClauseSequenceInfoDTOs.map(cs => {
            let selectedExtension=this.clauseExtensionClausesList.filter(item => item&&item.id&&item.id==cs.clauseExtensionId)
            if(selectedExtension&&selectedExtension.length>0) {
                clauseDiscriptionInSequence.push(selectedExtension[0]);
            }
           
        })
       
        console.log(clauseDiscriptionInSequence,"this.cecl");
        this.scopePreviewString='';
        if(this.scope.product=='SELLERS_INTEREST') {
            this.scopePreviewString='Seller\'s Interest ';
        } else if(this.scope.product=='BUYERS_INTEREST') {
            this.scopePreviewString='Buyer\'s Interest ';
        }
        console.log(this.clauseExtensionClausesList,"this.clauseExtensionClausesList");
        console.log(this.clauseExtensionDeductableList,"clauseExtensionDeductableList");
        console.log(this.extensionFinalArray,"extensionFinalArray");
        console.log(this.extensionDeductableFinalList,"extensionDeductableFinalList");
        /* this.clauseExtensionClausesList.map((clause, index) => {
            if(clause.clauseDescrition){
                this.scopePreviewString += clause.clauseDescrition + (index === (this.clauseExtensionClausesList.length - 1) ? '; ' : ', ');
            }
        }) */
        clauseDiscriptionInSequence.map((clause,index) => {
            if(clause&&clause.clauseDescrition) {
                this.scopePreviewString+=clause.clauseDescrition+(index===(this.clauseExtensionClausesList.length-1)? '; ':', ');
            }
        })
        this.clauseExtensionDeductableList.map((clauseExtension,index) => {
            if(clauseExtension&&clauseExtension.decuctableDescription&&this.scope.deductibleType!=='NO_DEDUCTIBLE') {
                this.scopePreviewString+=clauseExtension.decuctableDescription+(index===(this.clauseExtensionDeductableList.length-1)? '; ':', ');
            }
        })
        this.extensionFinalArray.map((extension,index) => {
            if(extension&&extension.extensionDescription) {
                this.scopePreviewString+=extension.extensionDescription+(index===(this.extensionFinalArray.length-1)? '; ':', ');
            }
        })
        this.extensionDeductableFinalList.map((extensionDeductable,index) => {
            if(extensionDeductable&&extensionDeductable.decuctableDescription&&this.scope.deductibleType!=='NO_DEDUCTIBLE') {
                this.scopePreviewString+=extensionDeductable.decuctableDescription+(index===(this.extensionDeductableFinalList.length-1)? '; ':', ');
            }
        })
        console.log(this.scopePreviewString,"this.scopePreviewString");
        this.scopePreviewString=this.scopePreviewString.replace(/;([^;]*)$/,'.')
    }

    onCategoryExtensionsSelect(event,extensionIndex,extensionDescriptionIndex) {
        if(event.target.checked) {
            this.extensionDeductableList[extensionIndex].clauseExtensionList[extensionDescriptionIndex]['checked']=true
        } else {
            this.extensionDeductableList[extensionIndex].clauseExtensionList[extensionDescriptionIndex]['checked']=false
        }
        this.extensionDeductableList=[...this.extensionDeductableList];
        this.getClauseExtensionDescription();
    }

    onClickIsLOIRequired(event) {
        // if(this.scope.isLOIRequired==undefined||!this.scope.isLOIRequired) {
        if(CommonUtils.isNil(this.scope.isLOIRequired)||!this.scope.isLOIRequired) {
            this.scope.isLOIRequired=true;
        } else {
            this.scope.isLOIRequired=false;
        }
        
    }

    manageDeductible(event) {
        // if(event.target.value==DeductableType.NO_DEDUCTIBLE) {
        //     this.clauseDeductableList.forEach(clause => {
        //         clause.clauseDeductables=[];
        //     });
        //     this.extensionDeductableList.forEach(ext => {
        //         ext.extensionDeductables=[];
        //     });
        // }
    }


    hideDeleteExtenstionModel() {
        this.deleteExtensionModel.hide();
    }

    proceedToDeleteExtenstion() {
        // this.processDeSelectExtension();
        // this.extenstionNamesBefore.delete(this.selectedExtension);
        this.deleteExtensionModel.hide();
        this.isShowWarningForExt=false;
        this.saveScope();
    }


    extNotPresentToDisplay=[];
    extNotPresent=[];
    checkExtensions() {
        let extAr=new Set();
        this.scope.extensionDeductables.forEach(ext => {
            ext.clauseExtensionList.forEach(item => {
                extAr.add(item.name);
            })
        })

        this.extNotPresent=[];
        this.extNotPresentToDisplay=[];
        this.extenstionNamesBefore.forEach((value: any,key: any) => {
            if(!extAr.has(key)) {
                this.extNotPresent.push(value.id);
                this.extNotPresentToDisplay.push(value);
                this.isShowWarningForExt=true;
            }
        })

        if(this.isShowWarningForExt&&this.extNotPresent.length>0) {
            let extObj={
                "scopeExtensionIds": this.extNotPresent
            }
            this.scopeService.findRulesByScopeIdAndExtension(this.scope.id,extObj).subscribe(res => {
                if(res&&res.body) {
                    let payload=res.body.payload;
                    let rules=payload.rules;

                    this.extNotPresent = this.extNotPresent.filter(ext => payload[ext]&&payload[ext]>0);
                    this.extNotPresentToDisplay = this.extNotPresentToDisplay.filter(ext => payload[ext.id]&&payload[ext.id]>0);

                    if(rules.length>0) {
                        this.rules=rules;
                        // this.selectedExtension=key;
                        this.deleteExtensionModel.show();
                    } else {
                        
                        this.extNotPresent=[];
                        this.extNotPresentToDisplay=[];
                        this.isShowWarningForExt=false;
                        this.showSequenceModal();
                    }
                }
            })
        }

        if(!this.isShowWarningForExt || this.extNotPresent.length==0) {
            this.showSequenceModal();
        }
    }


    deleteExtensionsFromRule() {

        if(this.isShowWarningForExt&&this.extNotPresent.length>0) {
            let extObj={
                "rules": this.rules,
                "scopeExtensionIds":this.extNotPresent
            }
            this.scopeService.deleteExtensionsFromRulesByScopeIdAndExtension(this.scope.id,extObj).subscribe(res => {
                if(res&&res.body&&res.body.payload) {
                    // this.rules=res.body.payload;
                    // this.selectedExtension=key;
                    this.jhiAlertService.success("Extension deleted successfully from rules");
                    this.isShowWarningForExt=true;
                    this.deleteExtensionModel.hide();
                } 
            })
        }
        
    }

  
    getClauseName(type: string) {
     
        // return changeCase.capitalCase(type);
        return type;
      }

    getClauseDescription(clause) {
        if(this.clauseExtensionDeductableList) {
            let data=this.clauseExtensionClausesList.filter(cl => clause.clauseExtensionId==cl.id)
            return data && data.length>0 ? data[0].clauseDescrition : '';
        }
            
    }
    
}
